<template>
  <div class="mt-5 leading-22 flex overflow-hidden">
    <div class="text-label text-14 min-w-45">{{ label }}：</div>

    <div v-if="!$slots.default" class="text-14 text-default flex-1" :class="twoLine ? 'line-clamp-2' : 'truncate'">
      {{ value || "-" }}
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "ListNewItem"
});
</script>
<script setup>
defineProps({
  label: String,
  value: String,
  twoLine: {
    type: Boolean,
    default: false
  }
});
</script>
